<template>
    <div component="VoicesLang">
        <btn
            v-for="lang in getLangs"
            :key="lang.id"
            @click="sendRequest(lang.id)"
            radius="smallRight"
            :text="lang.skratka"
            color="transparent"
            :class="{ selected: isSelected(lang) }"
            :style="getStyle(lang)"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'VoicesLang',

    methods: {
        ...mapActions(['loadActors', 'updateCharacter']),
        ...mapMutations(['appendActorsFilters', 'setSearchIsVisible']),

        isSelected(lang) {
            return this.getSelectedCharacter?.filter?.jazyk === lang.id;
        },

        sendRequest(lang) {
            this.getSelectedCharacter.filter.jazyk = lang;
            this.setSearchIsVisible(false);
            this.updateCharacter(this.getSelectedCharacter);
            this.appendActorsFilters({
                jazyk: lang,
                // Reset
                search: undefined,
                page: 1,
            });
            this.loadActors();
        },
    },

    computed: {
        ...mapGetters(['getLangs', 'getSelectedCharacter', 'getColorById']),

        getStyle() {
            return (lang) => {
                const color = this.getColorById(this.getSelectedCharacter.farba);
                const selected = this.getSelectedCharacter?.filter?.jazyk === lang.id;
                return selected ? 'background:' + color : '';
            };
        },
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='VoicesLang'] {
    position: absolute;
    display: flex;
    flex-direction: column;
    max-width: 30px;
    right: -29px;
    top: 47px;

    button {
        padding: 5px !important;
        height: 35px !important;
        background: transparent;

        &.selected {
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
            .text {
                color: white !important;
            }
        }

        &:hover:before {
            opacity: 0 !important;
        }
    }
}
</style>
